import React from 'react';
import { useMount } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';

import { colors } from '@crm-framework/theme';

import { getUnreadMessages } from '../../selectors';
import { notificationsActions } from '../../NotificationsStore';

import { NotificationBell } from './NotificationBell';

export const NotificationBellContainer: React.FC = () => {
  const dispatch = useDispatch();

  const unreadMessages = useSelector(getUnreadMessages);

  useMount(() => {
    dispatch(notificationsActions.startInit());
  });

  return (
    <NotificationBell
      unreadMessages={unreadMessages}
      unreadMessageStyles={{ border: `2px solid ${colors.SECONDARY}` }}
      limit={999}
    />
  );
};
